import React from 'react'

import MouseScroll from "../../Components/Scroll/MouseScroll";

import background_img from "../../images/UECO_image.png";

import { useTranslation } from "react-i18next";

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';

import './ExpoOverview.css?ver=1';

const ExpoOverview = () => {
    const { t } = useTranslation();

  return (
    <div className='overview-container'>
        {/*<div className='img-container'>
            <img src={background_img} />
  </div> */}
        
        <div className='title-container' id='title-container'>
            <h1 className='overview-title'>{t('expo_overview_title')}</h1>
            <h1 className='overview-title-desc'>{t('expo_overview_title_desc')}</h1>
        </div>
        {
            t("lang") == "ko"
            ?
            <div className='description-container'>
            <div className='overview-subtitle'>
                <p>
                    <h2 className='overview-highlight'>한국인 만명 게놈 사업</h2>의 성과와 <h2 className='overview-highlight'>노화</h2> 극복 시나리오 제시
                </p>
                <p>
                    <h2 className='overview-highlight'>게놈, 노화, 항암, 헬스케어, 제약, 미용</h2> 전문회사들과 연구자들을 위한
                </p>
                <p>
                    최첨단 게놈산업단지 발판 마련
                </p>
            </div>
            {/*<div className='overview-desc'>
                <p>
                    전 세계 유일 게놈·노화 엑스포, 게놈에서 노화까지
                </p>
                <p>
                    기업들이 참여가능한 만게놈 후속사업 / 규제자유특구 안내
                </p>
                <p>
                    세계 최고 게놈 전문가들이 보는 노화 극복 시나리오
                </p>
                </div>*/}
        </div>
        :
        <div className='description-container'>
        <div className='overview-subtitle'>
            <p>
                <h2 className='overview-highlight'>10,000 Korean Genome Project </h2> and Overcoming <h2 className='overview-highlight'>Aging</h2>
            </p>
            <p>
                A state-of-the-art Genome Industrial Complex for Enterprises and scholars from <h2 className='overview-highlight'>Genomics, Aging, Cancer, Pharmaceuticals, Healthcare, and Cosmetics.</h2>
            </p>
            </div>
        {/*<div className='overview-desc'>
            <p>
                전 세계 유일 게놈·노화 엑스포, 게놈에서 노화까지
            </p>
            <p>
                기업들이 참여가능한 만게놈 후속사업 / 규제자유특구 안내
            </p>
            <p>
                세계 최고 게놈 전문가들이 보는 노화 극복 시나리오
            </p>
            </div>*/}
        </div>
        }

        <MouseScroll />
    </div>
  )
}

export default ExpoOverview